import { Box } from '@mui/material'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-premium'
import React from 'react'

interface Props {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
}

const RenderOptimizationsColumn: React.FC<Props> = ({ params }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      {params?.value}
    </Box>
  )
}

export default RenderOptimizationsColumn
